module.exports = __webpack_public_path__ + "img/hello_sprechblase.376fc518.svg";